import Grid from "@material-ui/core/Grid";
import { withSnackbar } from "notistack";
import React, { Component } from "react";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import { radioinputconverter } from "Component/DynamicForm/Fields/Radio";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import DynamicForm from "Component/DynamicForm";
import { ErrorMessages } from "Constants";
import { instance } from "Actions/AxiosInstance";
import { textareainputconverter } from "Component/DynamicForm/Fields/Textarea";
import { isSpaceInString } from "Utils";


class define extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      postData: this.props.postData,
      addall: false,
    };

    this.onSubmit = this.onSubmit.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onSaveDraft = this.onSaveDraft.bind(this);
  }

  async componentDidMount() {
    this.props.onRef({
      onNext: this.onSubmit,
      onSaveDraft: this.state.postData.pipelineid ? "" : this.onSaveDraft,
    });
  }

  onSaveDraft() {
    const { postData } = this.state;
    postData.isdraft = true;
    if (!postData.name) {
      this.props.enqueueSnackbar("Please add pipeline  name", {
        variant: "error",
      });
    } else {
      instance
        .post("recruit/configpipeline", postData)
        .then(() => {
          this.props.enqueueSnackbar(ErrorMessages.E0000, {
            variant: "success",
          });
          this.props.history.push(`${this.props.match.path}`);
          this.props.getPipeline();
        })
        .catch((error) => {
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  handleChange(key, value) {
    const { postData } = this.state;
    postData[key] = value;
    this.setState({ postData });
  }

  onSubmit() {
    const { postData } = this.state;
    if (!postData.name) {
      this.props.enqueueSnackbar("Please add pipeline  name", {
        variant: "error",
      });
    } else if (postData.name && !isSpaceInString(postData.name)) {
      this.state.postData.name = this.state.postData.name.trim();
    }
 else {
      this.props.onNextClick(postData);
    }
  }


  handleBlur() {
    const { postData } = this.state;
    if (postData.name) {
      instance
        .post("recruit/checkuniquepipelinename", {
          name: postData.name,
          pipelineid: postData && postData.pipelineid,
        })
        .then((result) => {
          // postData[key] = value;
          // this.setState({ postData });
        })
        .catch((error) => {
          postData.name = "";
          this.setState({ postData });
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    }
  }

  render() {
    const { postData } = this.state;

    return (
      <div className="stepper-scroller padding-top-0">
        <Grid container>
          <Grid item xs={12} md={12} sm={12}>
            <div style={{ width: 300 }}>
              <DynamicForm
                fields={textinputconverter({
                  value: postData.name,
                  placeholder: "",
                  label: "Let’s give this pipeline a name",
                })}
                onChange={(value) => {
                  this.handleChange("name", value);
                }}
                onBlur={(e) => {
                  this.handleBlur();
                }}
              />
              <DynamicForm
                fields={textareainputconverter({
                  value: postData.description,
                  placeholder: "",
                  label: "Pipeline description",
                })}
                onChange={(value) => {
                  this.handleChange("description", value);
                }}
              />
            </div>
          </Grid>
        </Grid>
      </div>
    );
  }
}
export default withSnackbar(define);
